import { Component } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { LocalStorageService } from '@services/local-storage.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@Component({
    selector: 'language-switcher',
    templateUrl: './language-switcher.html',
    styleUrls: ['./language-switcher.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        BsDropdownModule
    ]
})
export class LanguageSwitcher {
    isActiveLanguage: string;
    languageName: string;

    constructor(private translate: TranslateService,
                private localStorageService: LocalStorageService) {
        let hasLangValue = this.localStorageService.hasValue('app.lang');

        if (hasLangValue) {
            let langValue = this.localStorageService.getLang();
            this.isActiveLanguage = langValue;
            this.languageName = this.isActiveLanguage === 'en' ? 'English' : this.isActiveLanguage === 'es' ? 'Spanish' : 'French';
            this.translate.use(langValue);
        }
    }

    /**
     * change language
     * @param lang - selected language
     */
    onChangeLanguage(lang) {
        this.isActiveLanguage = lang;
        this.languageName = this.isActiveLanguage === 'en' ? 'English' : this.isActiveLanguage === 'es' ? 'Spanish' : 'French';
        this.translate.use(lang);
        this.localStorageService.setLang(lang);
        location.reload();
    }
}
